import type { TranslationMessages } from '../../types';

export const common: TranslationMessages = {
  member: 'Thành viên',
  members: 'Thành viên',
  items_per_page: 'Mục mỗi trang',
  first_page: 'Trang đầu',
  last_page: 'Trang cuối',
  next_page: 'Trang sau',
  previous_page: 'Trang trước',
  visible_after_filter: 'hiển thị sau khi lọc theo vai trò',
};
